import template from './searchResults.html';

class SearchResultsController {
  constructor($element, _) {
    this.element = $element;
    this.domNode = $element[0];
    this.debounce = _.debounce;
  }

  checkDepth() {
    const currentDepth = this.domNode.scrollTop + this.domNode.offsetHeight;
    const targetDepth = this.domNode.scrollHeight - (this.domNode.scrollHeight * 0.01);

    return currentDepth >= targetDepth;
  }

  scrollHandler() {
    const containerBottom = this.checkDepth();
    if (containerBottom && !this.state.loadingMore) {
      this.loadMore();
    }
  }

  $postLink() {
    if (this.loadMore) {
      this.debouncedScrollHandler = this.debounce(this.scrollHandler.bind(this), 100);
      this.element.on('scroll', this.debouncedScrollHandler);
    }
  }

  $onDestroy() {
    if (this.debouncedScrollHandler) {
      this.element.off('scroll', this.debouncedScrollHandler);
    }
  }
}

SearchResultsController.$inject = ['$element', '_'];

const searchResults = {
  template,
  bindings: {
    state: '<',
    loadMore: '&?',
    hideAlert: '<'
  },
  transclude: true,
  controller: 'SearchResultsController'
};

export default function (ngModule) {
  ngModule.component('searchResults', searchResults);
  ngModule.controller('SearchResultsController', SearchResultsController);
}
